import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitScheduledModel } from '@apps-common/types/portal/unit-scheduled'

export const QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULE = (scheduledId?: number) =>
  ['getMyMonitoringUnitSchedule', scheduledId].filter(Boolean)

const getUnitScheduled = async (scheduledId: number): Promise<IUnitScheduledModel> =>
  axios.get(`/my-monitoring/sites/GetSchedule?scheduledId=${scheduledId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitScheduled

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
  scheduledId: number
}

export const useMyMonitoringGetUnitScheduled = ({ config, unitId, scheduledId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULE(scheduledId),
    queryFn: () => getUnitScheduled(scheduledId)
  })
